<template>
  <div id="login">
    <form @submit.prevent="doLogin" name="loginData">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <h2 class="text-center mb-5 mt-4">INICIO DE SESIÓN</h2>
          </div>
          <div class="col-sm-12">
            <input
              class="w-100 mb-3 mt-1 text"
              type="text"
              v-model="rut"
              placeholder="Rut"
              maxlength="12"
              autocomplete="username"
            />
          </div>
          <div class="col-sm-12">
            <input
              class="w-100 mb-1 text"
              v-model="password"
              type="password"
              placeholder="Contraseña"
              maxlength="5"
              autocomplete="current-password"
            />
          </div>
          <div class="col-sm-12">
            <input
              class="mt-5 btn-login ml-auto mr-auto w-75 d-block"
              type="submit"
              value="INGRESAR"
            />
          </div>
          <div class="col-sm-12">
            <img
              class="mt-5 ml-auto mr-auto d-block w-75"
              :src="logoURL"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'Login',
  data() {
    return {
      rut: '',
      password: '',
      logoURL: '/static/img/logo-toptransferchile.png', // valor por defecto
      company: 'toptransferchile',
    }
  },
  created() {
    // Obtener el nombre de la empresa y logo dinámicamente si existe en process.env
    if (process.env.COMPANY_NAME) {
      this.company = process.env.COMPANY_NAME
      this.logoURL = `/static/img/logo-${this.company}.png`
    }
    if (process.env.COMPANY_LOGO) {
      this.companyLogo = process.env.COMPANY_LOGO
      this.logoURL = `${this.companyLogo}`
    }
  },
  methods: {
    doLogin() {
      // Login especial de test
      if (this.rut === '222222222' && this.password === '12345') {
        localStorage.setItem('token', 'test')
        this.$router.push('/test')
        return
      }
      http.post('auth', {
        rut: this.rut,
        password: this.password
      })
        .then(res => {
          localStorage.setItem('token', res.body.token)
          localStorage.setItem('rut', this.rut.toLowerCase())
          this.$router.push('/menu')
        })
        .catch(err => {
          if (err.body && err.body.error === 'invalid_credentials') {
            alert('Los datos ingresados no son correctos.')
          } else if (err.status === 412) {
            alert(err.body.message)
          } else if (err.status === -1) {
            alert('Error de conexión: compruebe sus Datos Móviles o WIFI')
          } else {
            alert('Error: ' + err.status + ' - No se ha podido establecer conexión con el servidor')
          }
        })
    }
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/Login2.vue